import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../constants/urls";
import { faqQuestions } from "../data/faqQuestions";
import { absoluteAssetUrl, canonicalUrl, DEFAULT_IMAGE, SITE_NAME } from "./metadata";

const organizationId = `${canonicalUrl()}#organization`;
const websiteId = `${canonicalUrl()}#website`;
const organization = { "@type": "Organization", "@id": organizationId, name: SITE_NAME, url: canonicalUrl(), logo: absoluteAssetUrl("/logo512.png") };
const website = { "@type": "WebSite", "@id": websiteId, name: SITE_NAME, url: canonicalUrl(), inLanguage: "en", publisher: { "@id": organizationId } };

export function pageSchema(metadata, breadcrumbs, type = "WebPage") {
	const url = canonicalUrl(metadata.path);
	const nodes = [{
		"@type": type, "@id": `${url}#webpage`, url,
		name: metadata.title, description: metadata.description,
		inLanguage: "en", isPartOf: { "@id": websiteId },
	}];
	if (breadcrumbs) {
		nodes[0].breadcrumb = { "@id": `${url}#breadcrumb` };
		nodes.push({
			"@type": "BreadcrumbList", "@id": `${url}#breadcrumb`,
			itemListElement: breadcrumbs.map((item, index) => ({
				"@type": "ListItem", position: index + 1,
				name: item.name, item: canonicalUrl(item.path),
			})),
		});
	}
	// Resolve publisher and website references within every page's graph.
	return { "@context": "https://schema.org", "@graph": [...nodes, organization, website] };
}

export function homeSchema(metadata) {
	return {
		"@context": "https://schema.org",
		"@graph": [
			...pageSchema(metadata)["@graph"],
			{
				"@type": "MobileApplication", "@id": `${canonicalUrl()}#app`,
				name: SITE_NAME, url: canonicalUrl(), image: DEFAULT_IMAGE,
				description: "Score tracking for tennis, padel, pickleball, badminton, squash and ping pong, with match history and statistics.",
				applicationCategory: "SportsApplication", operatingSystem: "iOS, watchOS, Android",
				downloadUrl: [APP_STORE_URL, GOOGLE_PLAY_URL], publisher: { "@id": organizationId },
			},
			{
				"@type": "FAQPage", "@id": `${canonicalUrl()}#faq`,
				mainEntity: faqQuestions.map(({ question, answer }) => ({
					"@type": "Question", name: question,
					acceptedAnswer: { "@type": "Answer", text: answer },
				})),
			},
		],
	};
}

export function articleSchema(post, metadata) {
	const url = canonicalUrl(metadata.path);
	const schema = pageSchema(metadata, [
		{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }, { name: post.title, path: metadata.path },
	]);
	schema["@graph"].push({
		"@type": "BlogPosting", "@id": `${url}#article`,
		headline: post.title, description: metadata.description,
		image: absoluteAssetUrl(post.image), datePublished: post.date,
		...(post.updatedAt ? { dateModified: post.updatedAt } : {}),
		articleSection: post.category, inLanguage: "en",
		mainEntityOfPage: { "@id": `${url}#webpage` },
		publisher: { "@id": organizationId },
	});
	return schema;
}
